/**
 * @section 4.4
 */
import MaterialTabs from "@material-ui/core/Tabs";
import React from "react";
import { makeThemedStyles } from "./../utils";
const useStyles = makeThemedStyles("BottomNaviTabs", (theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    backdropFilter: "blur(0.45em)",
    backgroundColor: "rgb(11 40 45 / 60%)",
    color: "rgb(255 255 255)",
    transition: "all 0.01s",
    width: "100%",
  },
  scrollButtons: {
    width: "5.48em",
    height: "5.48em",
    borderRadius: "50%",
    backgroundColor: "rgb(67,105,110)",
    alignSelf: "center",
    marginLeft: "2.97em",
    marginRight: "2.97em",
    "& svg": {
      fontSize: "2.74em",
    },
  },
  scroller: {
    border: "0.1em solid",
    borderTopStyle: "none",
    borderBottomStyle: "none",
    borderRightColor: "rgb(255 255 255)",
    borderRightStyle: "solid",
    borderRightWidth: "0.1em",
    borderLeftColor: "rgb(255 255 255)",
    borderLeftStyle: "solid",
    borderLeftWidth: "0.1em",
    borderImage:
      "linear-gradient(to bottom, rgb(61 122 133), rgba(19, 65, 70, 0)) 3 100%",
  },
  flexContainer: {
    display: "block",
    textAlign: "center",
  },
  indicator: {
    transform: "translate(0px, -2.35em) scaleX(0.2)",
    backgroundColor: "rgb(17 94 103)",
    width: "24.8em",
  },
}));
type PropType = React.ComponentProps<typeof MaterialTabs>;
export const BottomNaviTabs: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStyles();
  return (
    <MaterialTabs
      {...props}
      classes={{
        scrollButtons: styles.scrollButtons,
        indicator: styles.indicator,
        scroller: styles.scroller,
        flexContainer: styles.flexContainer,
      }}
      className={styles.root}
    >
      {props?.children}
    </MaterialTabs>
  );
};
export default BottomNaviTabs;
